// Slot names can carry a unique suffix (e.g. `foo__1`) so the same slot/component
// can be reused with a unique object key. Strip it to get the base lookup key.
export const getBaseSlotName = (slotName) => slotName.split('__')[0];
